import Grid from '@mui/material/Grid2';
import { Box, Typography, IconButton } from '@mui/material';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DeleteIcon from '@mui/icons-material/Delete';

import localData from 'utils/localData';
import api from 'utils/api';
import logger from 'utils/logger';

import { formatBytes } from 'utils/misc';
import { generate8DigitsIdentifier } from 'utils/randomIdGenerator';
import { FILE_TYPE } from 'shared/constants/file';
import { USER_DATA } from 'shared/constants/users';
import { DOLPHIN_API } from 'shared/constants/apis';

const log = logger.createLogger('UploadMoreAttachmentsModalUtils');

export const startPeriodicStatusCheckForBatchAttachments = async (
  attachmentIds
) => {
  let status;
  try {
    const apiVariables = {
      params: {
        organizationId: localData.get(USER_DATA.CURRENT_ORGANIZATION_ID),
        attachmentIds: attachmentIds,
      },
    };
    const res = await api.get(
      `${DOLPHIN_API.ATTACHMENT}/periodic-status-check-attachments`,
      apiVariables
    );
    status = res.status;
  } catch (error) {
    log.error(
      `Request to /api/attachment/periodic-status-check-attachments failed; Check network condition;`
    );
    log.error(error);
  }

  return status;
};

export const checkForBatchAttachmentsCompletion = async (
  issueId,
  attachmentIds
) => {
  let status;
  try {
    const apiVariables = {
      params: {
        organizationId: parseInt(
          localData.get(USER_DATA.CURRENT_ORGANIZATION_ID)
        ),
        issueId: parseInt(issueId),
        attachmentIds: attachmentIds,
      },
    };
    const res = await api.get(
      `${DOLPHIN_API.ATTACHMENT}/check-for-attachments-completion-on-existing-issue`,
      apiVariables
    );
    status = res.status;
  } catch (error) {
    log.error(
      `Request to /api/attachment/check-for-attachments-completion-on-existing-issue failed; Check network condition;`
    );
    log.error(error);
  }

  return status;
};

export const generateFileList = (structuredAttachments, handleFileDelete) => {
  const res = structuredAttachments.map((item, index) => {
    if (item.type === FILE_TYPE.DIRECTORY) return <></>;
    return (
      <Box key={index}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid>
            <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
              {item.name} - {formatBytes(item.size)}
            </Typography>
          </Grid>
          <Grid>
            <IconButton onClick={handleFileDelete(index)}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
    );
  });

  return res;
};

export const generateDirectoryList = (
  structuredAttachments,
  handleFileDelete,
  darkMode
) => {
  const res = structuredAttachments.map((item, index) => {
    if (item.type === FILE_TYPE.FILE) return <></>;
    return (
      <Box key={index}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid>
            {item.type === FILE_TYPE.FILE ? (
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                {item.name} - {formatBytes(item.size)}
              </Typography>
            ) : (
              <SimpleTreeView
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                style={{
                  color: darkMode ? 'white' : 'black',
                  backgroundColor: darkMode ? '#202940' : 'white',
                }}
                sx={{
                  maxheight: 400,
                  flexGrow: 1,
                  maxWidth: 500,
                  overflowY: 'auto',
                }}>
                {generateTreeView(item)}
              </SimpleTreeView>
            )}
          </Grid>
          <Grid>
            <IconButton onClick={handleFileDelete(index)}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
    );
  });

  return res;
};

const generateTreeView = (structureObject) => {
  const label = `${structureObject.name}  -  ${formatBytes(
    structureObject.size
  )}`;
  return (
    <TreeItem
      itemId={`${structureObject.name}-${generate8DigitsIdentifier()}`}
      label={label}>
      {structureObject.type === FILE_TYPE.DIRECTORY &&
        structureObject.children.map((item) => generateTreeView(item))}
    </TreeItem>
  );
};
